import api from '@pray/shared/utils/api';

export const getStudioNotifications = async ({ artistId = null } = {}) => {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/notifications`;
  const response = await api.executeGetRequest(url);

  return response.data;
};
